import React from 'react'

import {
  EmptyState,
  EmptyStateIcon,
  EmptyStateText,
  EmptyStateTitle
} from 'components/common/EmptyState'
import Icon, { FontAwesomeIconName } from 'components/Icon'

export const EmptyStateMessage: React.FC<{
  icon: FontAwesomeIconName
  title?: string
  children?
}> = ({ icon = 'chartNetwork', title, children, ...rest }) => {
  return (
    <EmptyState {...rest}>
      <EmptyStateIcon>
        <Icon icon={icon} />
      </EmptyStateIcon>
      {title && (
        <EmptyStateTitle data-test-empty-state-message-header>
          {title}
        </EmptyStateTitle>
      )}
      <EmptyStateText data-test-empty-state-message-text>
        {children}
      </EmptyStateText>
    </EmptyState>
  )
}
